import { create } from 'zustand';

interface UIState {
  openEventsBySeason: Map<string, string>;
  toggleEvent: (season: string, event: string) => void;
  getOpenEvent: (season: string) => string | undefined;

  // Media modal state
  openMediaUrl: string | null;
  mediaType: 'image' | 'video' | null;
  openMediaModal: (url: string, type: 'image' | 'video') => void;
  closeMediaModal: () => void;
  isMediaModalOpen: boolean;

  // Toast state
  toastMessage: string | null;
  toastType: 'success' | 'error' | 'info';
  showToast: (message: string, type: 'success' | 'error' | 'info') => void;
  hideToast: () => void;
}

export const useUIStore = create<UIState>((set, get) => ({
  openEventsBySeason: new Map<string, string>(),
  
  toggleEvent: (season, event) => {
    set((state) => {
      const newMap = new Map(state.openEventsBySeason);
      const currentOpen = newMap.get(season);
      
      if (currentOpen === event) {
        // Close if same event is clicked
        newMap.delete(season);
      } else {
        // Open the new event
        newMap.set(season, event);
      }
      
      return { openEventsBySeason: newMap };
    });
  },
  
  getOpenEvent: (season) => {
    return get().openEventsBySeason.get(season);
  },
  
  // Media modal state
  openMediaUrl: null,
  mediaType: null,
  isMediaModalOpen: false,
  
  openMediaModal: (url, type) => {
    set({ 
      openMediaUrl: url,
      mediaType: type,
      isMediaModalOpen: true 
    });
  },
  
  closeMediaModal: () => {
    set({
      openMediaUrl: null,
      mediaType: null,
      isMediaModalOpen: false
    });
  },

  // Toast state
  toastMessage: null,
  toastType: 'info',

  showToast: (message, type) => set({
    toastMessage: message,
    toastType: type
  }),

  hideToast: () => set({
    toastMessage: null
  }),
}));
